<template>
  <div class="question-view hotspot" ref="questionView">
    <FixedFontSizeSelector class="fixedFontSizeSelector">
      <div class="quest">
        <div class="title">
          <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="form.title" :safe="false"/>
        </div>
      </div>
    </FixedFontSizeSelector>
    <div class="box" :style="`${mode == 'viewAnswer' ? `--beforeShow: '';` : `--beforeShow: none;`}`">
      <div class="quest-img" :style="{backgroundImage: `url(${form.img_url})`}">
        <!-- <img :src="form.img_url" alt=""> -->
      </div>
    </div>

  </div>
</template>

<script>
import HotspotDrag from './hotspotDrag/hotspotDrag'
import { _debounce } from '@/utils/throttle.js'
import FixedFontSizeSelector from '@/views/examination/components/dialog/FontSizeSelector'
export default {
  components: {
    FixedFontSizeSelector
  },
  props: ['form', 'mode'],
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      mathjaxNum: 0,
      letter,
      image: '',
      topic: '',
      map: [],
      hotspotData: [],

      drag: null,
      answer_results: {
        id: null,
        student_choices: []
      },
      recordQuestion: [],
      limit: 0,
    }
  },
  watch: {
    'form.id': {
      handler(){
        this.initData()
      },
      deep: true
    }
  },
  methods: {
    onRenderComplete(i) {
      let num = 1
      if(i == num) {
        this.$parent.loading = false
      }
    },
    resetting() {
      this.$emit('permissions', false)
      this.limit = 0

      let blocks = document.querySelectorAll('.block-style')
      for(let i = 0; i < blocks.length; i++) {
        let block = blocks[i]
        if(block.dataset.mark == 1) block.click()
      }

      this.recordQuestion = []
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.repariRecordQuestion()
    },
    repariRecordQuestion() {
      this.$emit('repariRecordQuestion', this.recordQuestion, this.limit)
    },
    showTrueFalse() {
      let { form, recordQuestion } = this,
          answers = form.answers.map(its => its.choice_id),
          blocks = document.querySelectorAll('.block-style')

      if(recordQuestion.length == 0) {
        return ;
      }

      this.limit = 1

      for(let i = 0; i < blocks.length; i++) {
        let block = blocks[i],
            {value} = block.dataset
        if(recordQuestion.some(its => its.choice_id == value)) {
          block.click()
        }
      }

      for(let i = 0; i < blocks.length; i++) {
        let block = blocks[i],
            {value, mark} = block.dataset

        if(mark != 1) continue;

        if(this.mode == 'question') {
          continue ;
        }
        if(answers.includes(Number(value))) {
          block.classList.add('block-style-success')
        } else {
          block.classList.add('block-style-error')
        }
      }
    },
    getNodeTotalHeight(dom) {
      if(!dom) return 0
      let styleData = window.getComputedStyle(dom, null)
      return dom.offsetHeight
          + Number(styleData.marginTop.replace('px', ''))
          + Number(styleData.marginBottom.replace('px', ''))
    },
    // ✅ 完全对齐参考代码的 sizeEvent
    sizeEvent() {
      let imgDom = document.querySelector('.quest-img'),
          iWidth = imgDom.clientWidth,
          imgBl = iWidth / 833,
          iHeight = 500 * imgBl

      imgDom.style.height = iHeight + 'px'

      for(let i = 0; i < this.map.length; i++) {
        let {width, height, x, y, uuid} = this.map[i],
            block = imgDom.querySelector(`#${uuid}`),
            bl = imgBl * 500 / 300

        if(block) {
          block.style.width = `${width * bl}px`
          block.style.height = `${height * bl}px`
          block.style.top = `${y * bl}px`
          block.style.left = `${x * bl}px`
        }
      }
    },
    initData() {
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.recordQuestion = []
      this.hotspotData = []

      this.drag = new HotspotDrag({
        plate: '.quest-img',
        useType: 'view',
      })
      this.map = []
      for(let i = 0; i < this.form.choices.length; i++) {
        let its = this.form.choices[i]
        this.map.push({
          ...JSON.parse(its.value),
          other: {
            id: its.id,
            position: its.position,
            type: its.type
          }
        })
      }
      this.drag.echoBlock(this.map, this)

      setTimeout(() => this.showTrueFalse(), 500)
      this.sizeEvent()
    }
  },
  mounted() {
    this.initData()

    window.onresize = _debounce(this.sizeEvent, 500)
    if (!this.form.img_url) {
      document.documentElement.style.setProperty('--selector-width', '100%');
    } else {
      document.documentElement.style.setProperty('--selector-width', '50%');
    }
  }
}
</script>

<style scoped lang="scss">
@import url('../../static/pubile.scss');
.fixedFontSizeSelector {
  width: var(--selector-width, 50%);
}
@media (max-width: 480px) {
  .fixedFontSizeSelector {
    width: var(--selector-width, 100%);
  }
}
.question-view {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border-radius: 10px;

  /* 核心：彻底禁止这个盒子里的下拉刷新 + 回弹 */
  overscroll-behavior: none;min-height: 0;
  .quest {
    .title {
      font-size: 15px;
      color: #333;
    }
  }
  .box {
    width: 100%;
    flex: 1;
    .quest-img {
      // ✅ 完全和参考代码 quest-img-dialog 一致
      width: 833px;
      height: 500px;
      margin-left: 0;
      background-color: #fff;
      background-size: 100% 100%;
      position: relative;
    }
  }
}
</style>

<style lang="scss">
.block-style {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 80px;
  left: 80px;
  cursor: pointer;
  z-index: 1;
  background-size: 100% 100%;
  box-sizing: border-box;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px dashed #333;
    box-sizing: border-box;
  }
}

.click-style {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  display: none;

  &:before {
    content: '';
    position: absolute;
    top: -5px;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 10px;
    height: 20px;
    border: 3px solid #007516;
    border-top: none;
    border-left: none;
    transform: rotateZ(50deg);
  }
}

.block-style-circle {
  position: absolute;
  top: 80px;
  left: 80px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
  background-color: transparent;
  background-size: 100% 100%;
  box-sizing: border-box;

  &:before {
    content: '';
    border-radius: 50%;
  }
}

.question-click-style {
  &:before {
    border: none !important;
  }
  .click-style {
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 100%;
      height: 100%;
      border: 3px dashed #007516;
      box-sizing: border-box;
    }
  }
}

.question-click-style.block-style-circle > .click-style:after  {
  content: '';
  border: 3px dashed #007516;
  border-radius: 50%;
  box-sizing: border-box;
}
</style>